"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isTag(tag) {
  var result = false;

  switch (tag) {
    case 'latest':
    case 'earliest':
    case 'pending':
      result = true;
      break;
  }

  return result;
}

exports.isTag = isTag;